// The plane's brain graph for the think player (components/BrainThink.js):
// `brainMeta/graph` as the summariser writes it, read once and cached.
// Rules allow operators only — for anyone else this resolves to null and
// the player shows the stages and the sources rail without a map.
import firebase from '../firebaseConfig';

let cached;
export async function loadBrainGraph() {
  if (cached !== undefined) return cached;
  try {
    const snap = await firebase.firestore().collection('brainMeta').doc('graph').get();
    cached = snap.exists ? JSON.parse(snap.data().graph || 'null') : null;
  } catch {
    cached = null;
  }
  return cached;
}

export const THINK_HREF = '/admin/brain/think';
